<template>
  <div class="">
    <div class="list">
      <span v-if="(authList && authList.length > 0) || (entryList && entryList.length > 0)" style="margin-bottom: 10px;">
        录入的产品与已经存在的产品重复，请确认ID或者包名是否填写错误，如未填写错误请按照下述详细解答获取产品权限，无需再次录入。
      </span>
      <span>{{ remove ? '产品已存在，是否需要剔除重复的产品并继续提交' : '' }}</span>
      <div 
        v-if="(listData && listData.length > 0)"
        class="list-item" 
        v-for="(item, index) in listData"
        :key="index"
      >
        <p v-if="item.tip">{{item.tip}}</p>
        <div v-if="hasNum">
            <span>序号：<i v-for="(chidlrenItem, chidlrenIndex) in item.error_num" :key="chidlrenIndex" style="font-style: normal;">
              {{chidlrenItem}}{{ item.error_num.length - 1 === chidlrenIndex? '' : '、'}}</i>
            </span>
        </div>
        
      </div>
      <AuthItems v-if="authList && authList.length > 0" :list="authList" />
      <ErrorItems v-if="entryList && entryList.length > 0" :list="entryList" />
    </div>
    <div class="btns tac">
      <el-button v-if="!remove" type="primary" @click="$emit('close')">已知晓</el-button>
      <template v-else>
          <el-button @click="$emit('close')">取消</el-button>
          <el-button type="primary" @click="handleSubmit">剔除</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import AuthItems from './authItems.vue'
import ErrorItems from './errorItems.vue'
export default {
    name: 'ErrDataTipModal',
    props: ['list', 'remove', 'cbs', 'hasNum', 'authList', 'entryList'],
    components: {
      AuthItems,
      ErrorItems
    },
    computed: {
      listData() {
        return this.list.map(v=> {
          return {
            ...v,
            index: [...new Set(v.index)].join('、')
          }
        })
      }
    },
    methods: {
      handleSubmit() {
        const data = this.list[0].index
        this.cbs.onSubmit(data)
      }
    }
}
</script>

<style lang="scss" scoped>
.list {
  max-height: 60vh;
  overflow-y: auto;
  &-item {
     margin-bottom: 15px;
    p,span {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        width: 6px;
        height: 6px;
        border: 1px solid #111;
        border-radius: 50%;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    p {
      padding-left: 20px;
      font-size: 14px;
      &::before {
        background: #111;
      }
    }
    span {
      font-size: 12px;
      display: inline-block;
      padding-left: 60px;
      margin-top: 10px;
      &::before {
        left: 44px;
      }
    }
  }
}
</style>